// Basic swiper.js carousel - https://swiperjs.com/
if (document.querySelector(".image-carousel .swiper")) {
  const scrollbar = document.querySelector('.swiper-scrollbar');
  let swiper = new Swiper('.image-carousel .swiper', {
    spaceBetween: 20,
    freeMode: {
      enabled: true,
    },
    scrollbar: {
      el: scrollbar,
      draggable: true,
      dragSize: 96,
      snapOnRelease: false,
    },
    allowTouchMove: true,
    speed: 300,
    slidesPerView: 'auto',
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    breakpoints: {
      // when window width is >= 320px
      1280: {
        spaceBetween: 50,
        scrollbar: {
          dragSize: 244,
        },
      },
      // when window width is >= 480px
      720: {
        spaceBetween: 30,
      },

    }
  });
}

let mapSwipers = document.querySelectorAll(".map-container .map-swiper");

if (mapSwipers) {
  mapSwipers.forEach(() => {
    let mapSwiper = new Swiper('.map-container .map-swiper', {
      freeMode: {
        enabled: true,
      },
      slidesPerView: 'auto',
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        dragSize: 90,
        snapOnRelease: false,
      },
      allowTouchMove: true,
    });

    const swiperWrapper = document.querySelector(".map-container .map-swiper .swiper-wrapper");
    const scrollBar = document.querySelector(".map-container .map-swiper .swiper-scrollbar");
    const scrollBarDrag = document.querySelector(".map-container .map-swiper .swiper-scrollbar .swiper-scrollbar-drag");

    // setTimeout(() => {
    //     swiperWrapper.style.transform = "translate3d(-43%, 0px, 0px)";
    //     scrollBarDrag.style.transform = `translate3d(${(scrollBar.offsetWidth / 2) - 45}px, 0px, 0px)`;
    // }, 100);
  })
}